import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LayoutGrid } from "lucide-react";
import { fetchCategories } from "../lib/api";
import { CATEGORY_IMAGES } from "../data/categoryImages";
import { CATEGORY_LINKS } from "../data/categories";
import Seo from "../components/Seo";
import Reveal from "../components/Reveal";

export default function ShopIndex() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    fetchCategories()
      .then((d) => {
        const map = {};
        d.items.forEach((c) => {
          map[c.slug] = c.product_count;
        });
        setCounts(map);
      })
      .catch(() => {});
  }, []);

  return (
    <main data-testid="shop-index-page">
      <Seo
        title="Shop by Category | Farmacy District DC"
        description="Browse the Farmacy District DC menu by category — flower strains, pre-rolls, edibles, vapes, concentrates, shatter and deals. Fast DC delivery, 21+."
      />
      <section className="bg-brand-ink py-16 text-white grain sm:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-lime">The Menu</p>
            <h1 className="mt-3 font-display text-4xl font-black tracking-tighter sm:text-6xl">Shop by Category</h1>
            <p className="mt-4 max-w-lg text-sm leading-relaxed text-neutral-400">
              Premium flower, pre-rolls, edibles, vapes, concentrates and more — delivered fast and discreet across DC.
            </p>
            <Link
              to="/shop/all"
              data-testid="shop-index-all-products"
              className="mt-7 inline-flex items-center gap-2 rounded-full bg-brand-lime px-7 py-3.5 text-sm font-bold tracking-wide text-brand-ink transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-brand-limehover"
            >
              <LayoutGrid className="h-4 w-4" /> VIEW ALL PRODUCTS
            </Link>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-20">
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-6">
          {CATEGORY_LINKS.map((c, i) => (
            <Reveal key={c.slug} delay={(i % 4) * 0.05}>
              <Link
                to={`/category/${c.slug}`}
                data-testid={`shop-index-card-${c.slug}`}
                className="group block rounded-2xl bg-brand-sand p-6 text-center transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(0,0,0,0.08)] sm:p-8"
              >
                <div className="flex h-32 items-center justify-center sm:h-44">
                  {CATEGORY_IMAGES[c.slug] && (
                    <img
                      src={CATEGORY_IMAGES[c.slug]}
                      alt={`${c.label} category`}
                      loading="lazy"
                      className="max-h-full w-auto object-contain transition-transform duration-500 ease-out group-hover:scale-105"
                    />
                  )}
                </div>
                <h2 className="mt-4 font-display text-base font-black uppercase tracking-wide sm:text-lg">{c.label}</h2>
                <span className="mx-auto mt-2 block h-1 w-8 rounded-full bg-brand-lime transition-[width] duration-300 group-hover:w-12" />
                <p className="mt-2 text-[11px] font-semibold text-neutral-400">
                  {counts[c.slug] ?? ""} {counts[c.slug] != null ? "products" : ""}
                </p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
